/* ──────────────────────────────────────────────────────────────
 *  C1SnubberDialog — C1 Bushing snubber height notice
 *
 *  Shown after C1 bushing computation to inform the user that
 *  the axial snubber height defaults to 4 mm.
 *
 *  Ported from BushingApp.c1_snubber_dialog (optibush.py).
 * ────────────────────────────────────────────────────────────── */

import React from 'react';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';

import DialogShell from '@/components/DialogShell';
import { useUIStore } from '@/stores/useUIStore';

const C1SnubberDialog: React.FC = () => {
  const open = useUIStore((s) => s.c1SnubberDialogOpen);
  const closeDialog = useUIStore((s) => s.closeDialog);

  const handleClose = () => closeDialog('c1SnubberDialog');

  return (
    <DialogShell
      open={open}
      onClose={handleClose}
      title="C1 Bushing - Snubber Height"
      titleColor="info.main"
      icon={<InfoIcon color="info" sx={{ fontSize: 28 }} />}
      maxWidth={550}
      actions={
        <Button variant="contained" color="info" onClick={handleClose}>
          OK
        </Button>
      }
    >
      The current axial snubber height is set to 4 mm. Please adjust axial
      travel and distance between top of the core to bottom side of the collar
      of the sleeve manually as required.
    </DialogShell>
  );
};

export default C1SnubberDialog;
